const rootItems = [
    { id: 1, name: 'Group of items', description: 'Phasellus dapibus quam quis diam. Pellentesque habitant morbi tristique senectus et netus et.', image: 'static/images/cards/1.jpg', isGroup: true },
    { id: 2, name: 'Green Item', description: 'Sed et libero. Proin mi. Aliquam gravida mauris ut mi.', image: 'static/images/cards/2.jpg', isGroup: false },
    { id: 3, name: 'Blue Item', description: 'Nam porttitor scelerisque neque. Nullam nisl. Maecenas malesuada fringilla est. Mauris eu turpis.', image: 'static/images/cards/3.jpg', isGroup: false },
    { id: 4, name: 'Red Item', description: 'Proin vel arcu eu odio tristique pharetra. Quisque ac libero nec ligula consectetuer rhoncus.', image: 'static/images/cards/4.jpg', isGroup: false },
    { id: 5, name: 'Purple Item', description: 'Cras dictum ultricies ligula. Nullam enim. Sed nulla ante.', image: 'static/images/cards/5.jpg', isGroup: false }
];

const groupItems = [
    { id: 6, name: 'Dark subgroup', description: 'Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.', image: 'static/images/cards/6.jpg', isGroup: true },
    { id: 7, name: 'Light subgroup', description: 'Donec fringilla. Donec feugiat metus sit amet ante. Vivamus non.', image: 'static/images/cards/7.jpg', isGroup: true },
    { id: 8, name: 'Gold Item', description: 'Cras convallis convallis dolor. Quisque tincidunt pede ac urna.', image: 'static/images/cards/8.jpg', isGroup: false },
    { id: 9, name: 'Silver Item', description: 'Curabitur ut odio vel est tempor bibendum. Quisque ac libero nec ligula consectetuer rhoncus.', image: 'static/images/cards/9.jpg', isGroup: false },
    { id: 10, name: 'Bronze Item', description: 'Maecenas ornare egestas ligula. Vivamus nibh dolor, nonummy ac, feugiat non, lobortis quis, pede.', image: 'static/images/cards/10.jpg', isGroup: false }
];

const darkSubgroupItems = [
    { id: 11, name: 'Black Item', description: 'Aliquam erat volutpat. Nulla dignissim. Maecenas ornare egestas ligula.', image: 'static/images/cards/11.jpg', isGroup: false },
    { id: 12, name: 'Brown Item', description: 'Maecenas ornare egestas ligula. Nullam feugiat placerat.', image: 'static/images/cards/12.jpg', isGroup: false }
];

const lightSubgroupItems = [
    { id: 13, name: 'Yellow Item', description: 'Nunc mauris elit, dictum eu, eleifend nec, malesuada ut.', image: 'static/images/cards/13.jpg', isGroup: false },
    { id: 14, name: 'Orange Item', description: 'Quisque imperdiet, erat nonummy ultricies ornare, elit elit fermentum risus.', image: 'static/images/cards/14.jpg', isGroup: false }
];

export default {
    get: function (url) {
        return new Promise(function (resolve, reject) {
            var matches = url.match(/^\/api\/catalog\/getItems\/(\d+)/);
            if (matches.length === 2) {
                const id = matches[1];
                let result = rootItems;
                switch (id) {
                    case '1':
                        result = groupItems;
                        break;
                    case '6':
                        result = darkSubgroupItems;
                        break;
                    case '7':
                        result = lightSubgroupItems;
                        break;
                }

                resolve({
                    body: result
                });
                return;
            }
            reject();
        });
    }
};



// WEBPACK FOOTER //
// ./test/data/catalog/getItems.js